<template lang="pug">
div
    table.data-table(:style="fixedExp")
        slot
        tbody(v-if="!total && !loading")
            tr
                td#colspanNoData.noresult(:colspan='thAmount') 暂无数据
        tbody(v-if="loading && !list.length")
            tr
                td#colspanLoading(:colspan='thAmount', style="text-align: center;")
                    img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
    v-pagination(v-if="needpagination && ifPagination", :total="total", :pn="pn", :ps="ps", @updatepage="getPageData")
</template>

<script>
    import Vue from 'vue'
    import Pagination from './pagination.vue'
    import Resource from 'vue-resource'

    Vue.use(Resource);

    export default {
        props: {
            //请求数据的Ajax URL
            url: {
                required: true
            },
            //处理返回数据
            datafilter : {
                type: Function
            },
            //配置是否需要分页
            needpagination: {
                default: true
            },
            //初始化的时候是否默认执行一次getPageData
            initrequest: {
                default: true,
                type: Boolean
            },
            fixed: [String, Boolean]
        },
        components: {
            'pagination': Pagination
        },
        watch: {
            url (newVal, oldVal) {
                this.getPageData(1);
            }
        },
        data () {
            return {
                list: [],
                total: 0,
                ps: 10,
                pn: 1,
                loading: true,
                thAmount: 1,
                ifPagination: true,
                fixedExp: !!this.fixed ? {'table-layout': 'fixed'} : {}
            }
        },
        methods: {
            updateColspan() {
                if (this.$el) {
                    let trElem = this.$el.querySelector("tr");
                    let loadingElem = this.$el.querySelector("#colspanLoading");
                    this.thAmount = trElem.querySelectorAll("th").length || trElem.querySelectorAll("td").length;
                    loadingElem && loadingElem.setAttribute("colspan", this.thAmount);
                }
            },
            /**
             * Ajax获取Table数据
             * pn: 页码，根据页码获取该页数据
             * ajax 请求返回的数据格式若如下，则可不传datafilter处理函数：
             * {
             *      errno: 0,
             *      errmsg: '',
             *      total: 100,
             *      list: []
             * }
             */
            getPageData (pn) {
                if (!this.url) {
                    return;
                }
                this.loading = true;
                this.pn = pn; //设置组件Pagination的当前页码

                let params = '';
                if (this.needpagination) {
                    params = (/[?]/.test(this.url) ? '&' : '?') + `pg=${pn}&ps=${this.ps}`;
                }

                this.$http.get(this.url + params).then(res => {
                    let data = res.data;

                    this.ifPagination = true;

                    if(data.errno)  throw data;
    
                    if (typeof this.datafilter === 'function') {  //若传入数据处理函数，则处理该数据
                        data = this.datafilter(data);  //数据处理函数返回的数据需满足上面的格式
                    }

                    //规避错误：若在最后一页只有一条数据且将其删除，再次请求当前页就会出现错误，此时需要pn-1，请求上一页直到 0
                    // if(this.pn > 1 && data.total <= this.ps*(this.pn-1)){
                    //     // this.pn = this.pn-1;
                    //     this.refresh();
                    // }

                    this.loading = false;
                    this.total = +data.total || 0;
                    this.list = data.list;
                    this.ifPagination = !!this.total;
                    this.$emit("getdata", data.list, this.total);
                }).catch((e) => {
                    this.list = [];
                    this.total = 0;
                    this.$emit("getdata", null);
                })
            },
            /**
             * 刷新当前页
             */
            refresh () {
                this.getPageData(this.pn);
            }
        },
        mounted () {
            if(this.initrequest){
                this.getPageData(1);
            }
            this.updateColspan();
        },
        updated () {
            let colspanNoData = this.$el.querySelector("#colspanNoData");
            if (colspanNoData) {
                colspanNoData.setAttribute("colspan", this.thAmount);
            }
        },
        events: {
            needupdate () {
                this.refresh();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// data-table.vue?76355906